<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="upload_24px">
        <path id="icon/file/upload_24px" fill-rule="evenodd" clip-rule="evenodd"
            d="M15 10.5V16.5H9V10.5H5L12 3.5L19 10.5H15ZM19 20.5V18.5H5V20.5H19Z" fill="#CD9DFF" />
    </g>
</svg>
    